import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { backgroundColorDarkTheme } from '../../styles/global.styles';

interface DefaultLayoutProps {
  children?: ReactNode;
  padding?: number;
}

const DefaultLayout = ({ children, padding }: DefaultLayoutProps) => {
  return (
    <Box
      sx={{
        backgroundColor: backgroundColorDarkTheme,
        width: '100${window.innerWidth}px',
        minHeight: '100vh',
        p: { xs: 0, sm: 0, md: padding ?? 3 },
        ml: { xs: 0, sm: 0, md: 10 },
      }}
    >
      {children}
    </Box>
  );
};

export default DefaultLayout;
